import { useFadeIn } from '@hooks/useFadeIn'
import { contact, specializations } from '@content/portfolioData'
import { lookingFor } from '@content/storyInsights'

export function Contact() {
  const fade = useFadeIn()

  return (
    <section id="contact" ref={fade.ref as React.RefObject<HTMLElement>} className={`modern-section ${fade.className}`}>
      <p className="modern-section__label">Contact</p>
      <h2 className="modern-section__title">Get in touch</h2>
      <p className="modern-about__text" style={{ marginBottom: '1.5rem' }}>
        Interested in AI development, accessible technology, or open-source
        collaboration? I'm always open to meaningful conversations.
      </p>
      <div className="modern-contact__grid">
        <a href={`mailto:${contact.email}`} className="modern-contact__link">
          <span className="modern-contact__icon">@</span>
          {contact.email}
        </a>
        <a href={contact.github} className="modern-contact__link" target="_blank" rel="noopener noreferrer">
          <span className="modern-contact__icon">GH</span>
          GitHub
        </a>
        <a href={contact.linkedin} className="modern-contact__link" target="_blank" rel="noopener noreferrer">
          <span className="modern-contact__icon">in</span>
          LinkedIn
        </a>
      </div>

      <div className="modern-contact__looking-for">
        <p className="modern-section__label">What I'm Looking For</p>
        <ul className="modern-contact__looking-for-list">
          {lookingFor.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <p className="modern-section__label">Specializations</p>
        <div className="modern-expertise__items" style={{ marginTop: '0.5rem' }}>
          {specializations.map((s) => (
            <span key={s} className="modern-expertise__item">{s}</span>
          ))}
        </div>
      </div>
    </section>
  )
}
